export default "__VITE_ASSET__LaIThN59__"